"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FancyTextIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const FancyTextIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M27.7564 5.33334H5.08984L4.06828 8.92158C3.85487 9.6712 4.29451 10.4334 5.05026 10.624C5.806 10.8146 6.59166 10.3614 6.80507 9.61177L7.26393 8.00001L14.6666 8.00001V24H11.9999C11.2635 24 10.6666 24.597 10.6666 25.3333C10.6666 26.0697 11.2635 26.6667 11.9999 26.6667H19.9999C20.7363 26.6667 21.3333 26.0697 21.3333 25.3333C21.3333 24.597 20.7363 24 19.9999 24H17.3333V8.00001L25.5823 8.00001L26.0412 9.61183C26.2546 10.3615 27.0403 10.8146 27.796 10.624C28.5518 10.4335 28.9914 9.67127 28.778 8.92165L27.7564 5.33334Z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 }) })));
};
exports.FancyTextIcon = FancyTextIcon;
//# sourceMappingURL=text_fancy_icon.js.map